
export default class TutorialBreifSummary
{

    /** @type {number} */
    Index;

    /** @type {number} */
    TutorialId;

    /** @type {boolean} */
    IsActive;

    /** @type {string} */
    Title;
    
    /** @type(string) */
    Slug;

    /** @type {string} */
    Icon;

    /** @type {string} */
    RedirectionUrl;

    /** @type {string} */
    Description;

    /** @type {string} */
    Author;

}